import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { useEditorStore } from "../../domain/redux/hooks";
import { selectSelection } from "../../domain/selectors";
import { selectionEntityId } from "../../domain/selection/entity-id";
import type { TSetEmailBuilderActivePanel } from "./useEmailBuilderPanelSlide";

export function useEmailBuilderAddPanelCloseOnCanvasSelection(args: {
  setActivePanel: TSetEmailBuilderActivePanel;
}): void {
  const { setActivePanel } = args;
  const dispatch = useAppDispatch();
  const mode = useAppSelector(store => store.emailBuilderStore.mode);
  const activePanel = useAppSelector(store => store.emailBuilderStore.activePanel);
  const selection = useEditorStore(selectSelection);
  const selectionKey = selectionEntityId(selection) ?? "email";
  const previousSelectionKeyRef = useRef(selectionKey);
  const previousActivePanelRef = useRef(activePanel);

  useEffect(() => {
    if (mode !== "design") {
      previousSelectionKeyRef.current = selectionKey;
      previousActivePanelRef.current = activePanel;
      return;
    }

    const selectionChanged = previousSelectionKeyRef.current !== selectionKey;
    previousSelectionKeyRef.current = selectionKey;
    const wasAddPanelOpen = previousActivePanelRef.current === "add-elements";
    previousActivePanelRef.current = activePanel;

    if (
      wasAddPanelOpen &&
      selectionChanged &&
      activePanel === "add-elements" &&
      selection.kind !== "column"
    ) {
      setActivePanel("none");
    }
  }, [activePanel, dispatch, mode, selectionKey, setActivePanel]);
}
